import * as React from "react"
import "../styles/styles.sass"
import SidebarNavigation from "../components/sidebarNavigation"
import FontPreviewCell from "../components/fontPreviewCell"
import ColorPreviewCell from "../components/colorPreviewCell"
import TitleBar from "../components/titleBar"

function VisualsTabbedView(props) {
  const [tabSelection, setTab] = React.useState('item1')

  const handleItem1Change = () => {
    setTab('item1')
  }

  const handleItem2Change = () => {
    setTab('item2')
  }

  const handleItem3Change = () => {
    setTab('item3')
  }

  const handleItem4Change = () => {
    setTab('item4')
  }

  return (
    <div className="viewWindow">
      <TitleBar
        title="Visuals"
        actions={
          <div className="segments">
            <label className="segmentItem" htmlFor="item1">
              <input type="radio" checked={tabSelection === 'item1'} onChange={handleItem1Change} id="item1"/>
              <span className="segmentTitle">Colors</span>
            </label>

            <label className="segmentItem" htmlFor="item2">
              <input type="radio" checked={tabSelection === 'item2'} onChange={handleItem2Change} id="item2"/>
              <span className="segmentTitle">Fonts</span>
            </label>

            <label className="segmentItem" htmlFor="item3">
              <input type="radio" checked={tabSelection === 'item3'} onChange={handleItem3Change} id="item3"/>
              <span className="segmentTitle">Marketing</span>
            </label>

            <label className="segmentItem" htmlFor="item4">
              <input type="radio" checked={tabSelection === 'item4'} onChange={handleItem4Change} id="item4"/>
              <span className="segmentTitle">Effects</span>
            </label>
          </div>
        }
      />
      <div className="viewContent">
        <VisualsContent selection={tabSelection} />
      </div>
    </div>
  )
}

function VisualsContent(props) {
  const { selection } = props
  switch(selection) {
    case 'item1':
      return (
        <div className="visualsContent">
          <div className="colorTable">
            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Title"
                colorVariable="colorTitle"
                colorDescription="Color for titles (primary non-interactive text elements)."
                colorValue="Gray 700"
              />
            
              <ColorPreviewCell
                colorName="Title Placeholder"
                colorVariable="colorTitlePlaceholder"
                colorDescription="Color for title placeholders (e.g. text field input placeholder)."
                colorValue="Gray 300"
              />
            </div>

            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Subtitle"
                colorVariable="colorSubtitle"
                colorDescription="Color for subtitles (secondary non-interactive text elements)."
                colorValue="Gray 400"
              />
            </div>

            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Heading"
                colorVariable="colorHeading"
                colorDescription="Color for headings (titles of lists or content sections)."
                colorValue="Gray 600"
              />
            </div>

            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Action"
                colorVariable="colorAction"
                colorDescription="Color for most interactive elements - buttons, text, and icons. Each product should override this value."
                colorValue="#404C63"
              />
            
              <ColorPreviewCell
                colorName="Action Translucent"
                colorVariable="colorActionTranslucent"
                colorDescription="Translucent color for backgrounds of most translucent actions - to be used with Action color. Each product should override this value."
                colorValue="System Action, 0.08"
              />

              <ColorPreviewCell
                colorName="Action Disabled"
                colorVariable="colorActionDisabled"
                colorDescription="Disabled action color - to be used when action or tint color is disabled."
                colorValue="Gray 400, 0.48"
              />
            
              <ColorPreviewCell
                colorName="Action Translucent Disabled"
                colorVariable="colorActionTranslucentDisabled"
                colorDescription="Disabled translucent action color."
                colorValue="Gray 400, 0.08"
              />
            </div>

            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Tint"
                colorVariable="colorTint"
                colorDescription="Color for primary actions and CTAs. Each product should override this value."
                colorValue="#5085EB"
              />
            
              <ColorPreviewCell
                colorName="Tint Translucent"
                colorVariable="colorTintTranslucent"
                colorDescription="Translucent color for backgrounds of primary translucent actions and CTAs - to be used with Tint color. Each product should override this."
                colorValue="System Tint, 0.16"
              />
            </div>

            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Background Primary"
                colorVariable="colorBackgroundPrimary"
                colorDescription="Color for top-level backgrounds."
                colorValue="White"
              />
            
              <ColorPreviewCell
                colorName="Background Secondary"
                colorVariable="colorBackgroundSecondary"
                colorDescription="Colors for mid-level backgrounds."
                colorValue="Gray 100"
              />

              <ColorPreviewCell
                colorName="Background Tertiary"
                colorVariable="colorBackgroundTertiary"
                colorDescription="Colors for lowest-level backgrounds."
                colorValue="Gray 200"
              />
            </div>

            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Separator"
                colorVariable="colorSeparator"
                colorDescription="Color for separators and borders."
                colorValue="Black 0.08"
              />
            
              <ColorPreviewCell
                colorName="Overlay"
                colorVariable="colorOverlay"
                colorDescription="Color for overlays - backgrounds behind dialogs and sheets."
                colorValue="Black 0.4"
              />
            </div>

            <div className="colorsColumn">
              <ColorPreviewCell
                colorName="Destructive"
                colorVariable="colorDestructive"
                colorDescription="Color for actions that result in deletion / removal."
                colorValue="#E45A4F"
              />
            
              <ColorPreviewCell
                colorName="Destructive Translucent"
                colorVariable="colorDestructiveTranslucent"
                colorDescription="Translucent color for actions that result in deletion / removal."
                colorValue="Destructive, 0.16"
              />
            </div>
          </div>

          <h3 className="sectionTitle">Static Colors</h3>
          <div className="colorTable staticColors">
            <div className="colorsRow">
              <ColorPreviewCell
                colorName="White"
                colorVariable="colorWhite"
                colorDescription=""
                colorValue="#FFFFFF"
              />
            
              <ColorPreviewCell
                colorName="Gray 100"
                colorVariable="colorGray100"
                colorDescription=""
                colorValue="#F1F1F1"
              />

              <ColorPreviewCell
                colorName="Gray 200"
                colorVariable="colorGray200"
                colorDescription=""
                colorValue="#E5E5E6"
              />

              <ColorPreviewCell
                colorName="Gray 300"
                colorVariable="colorGray300"
                colorDescription=""
                colorValue="#C4C4C4"
              />
            </div>

            <div className="colorsRow">
              <ColorPreviewCell
                colorName="Gray 400"
                colorVariable="colorGray400"
                colorDescription=""
                colorValue="#98989A"
              />
            
              <ColorPreviewCell
                colorName="Gray 500"
                colorVariable="colorGray500"
                colorDescription=""
                colorValue="#636367"
              />

              <ColorPreviewCell
                colorName="Gray 600"
                colorVariable="colorGray600"
                colorDescription=""
                colorValue="#3B3B40"
              />

              <ColorPreviewCell
                colorName="Gray 700"
                colorVariable="colorGray700"
                colorDescription=""
                colorValue="#1F1F24"
              />
            </div>

            <div className="colorsRow">
              <ColorPreviewCell
                colorName="Gray 800"
                colorVariable="colorGray800"
                colorDescription=""
                colorValue="#1D1D20"
              />
            
              <ColorPreviewCell
                colorName="Gray 900"
                colorVariable="colorGray900"
                colorDescription=""
                colorValue="#111112"
              />

              <ColorPreviewCell
                colorName="Black"
                colorVariable="colorBlack"
                colorDescription=""
                colorValue="#000000"
              />

              <ColorPreviewCell
                colorName="Clear"
                colorVariable="colorClear"
                colorDescription=""
                colorValue=""
              />
            </div>

          </div>
        </div>
      )
    case 'item2':
      return (
        <div className="visualsContent">
          <FontPreviewCell fontStyle="font-large-title" fontName="Large Title" fontSize="42" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-title-1" fontName="Title 1" fontSize="32" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-title-2" fontName="Title 2" fontSize="24" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-title-3" fontName="Title 3" fontSize="20" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-body-1" fontName="Body 1" fontSize="18" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="font-body-1-emphasized" fontName="Body 1 Emphasized" fontSize="18" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-body-2" fontName="Body 2" fontSize="16" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="font-body-2-emphasized" fontName="Body 2 Emphasized" fontSize="16" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-body-3" fontName="Body 3" fontSize="14" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="font-body-3-emphasized" fontName="Body 3 Emphasized" fontSize="14" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-button-1" fontName="Button 1" fontSize="16" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="font-button-2" fontName="Button 2" fontSize="14" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="font-footnote" fontName="Footnote" fontSize="12" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="font-footnote-emphasized" fontName="Footnote Emphasized" fontSize="12" fontWeight="Bold"/>
          <FontPreviewCell fontStyle="font-caption-1" fontName="Caption 1" fontSize="13" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="font-caption-2" fontName="Caption 2" fontSize="12" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="font-caption-3" fontName="Caption 3" fontSize="10" fontWeight="Medium"/>
        </div>
        )
    case 'item3':
      return (
        <div className="visualsContent">
          <FontPreviewCell fontStyle="text-9xl font-normal" fontName="9XLarge" fontSize="128px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-9xl font-medium" fontName="9XLarge" fontSize="128px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-9xl font-bold" fontName="9XLarge" fontSize="128px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-8xl font-normal" fontName="8XLarge" fontSize="96px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-8xl font-medium" fontName="8XLarge" fontSize="96px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-8xl font-bold" fontName="8XLarge" fontSize="96px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-7xl font-normal" fontName="7XLarge" fontSize="72px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-7xl font-medium" fontName="7XLarge" fontSize="72px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-7xl font-bold" fontName="7XLarge" fontSize="72px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-6xl font-normal" fontName="6XLarge" fontSize="60px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-6xl font-medium" fontName="6XLarge" fontSize="60px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-6xl font-bold" fontName="6XLarge" fontSize="60px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-5xl font-normal" fontName="5XLarge" fontSize="48px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-5xl font-medium" fontName="5XLarge" fontSize="48px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-5xl font-bold" fontName="5XLarge" fontSize="48px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-4xl font-normal" fontName="4XLarge" fontSize="36px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-4xl font-medium" fontName="4XLarge" fontSize="36px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-4xl font-bold" fontName="4XLarge" fontSize="36px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-3xl font-normal" fontName="3XLarge" fontSize="30px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-3xl font-medium" fontName="3XLarge" fontSize="30px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-3xl font-bold" fontName="3XLarge" fontSize="30px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-2xl font-normal" fontName="2XLarge" fontSize="24px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-2xl font-medium" fontName="2XLarge" fontSize="24px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-2xl font-bold" fontName="2XLarge" fontSize="24px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-xl font-normal" fontName="XLarge" fontSize="20px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-xl font-medium" fontName="XLarge" fontSize="20px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-xl font-bold" fontName="XLarge" fontSize="20px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-lg font-normal" fontName="Large" fontSize="18px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-lg font-medium" fontName="Large" fontSize="18px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-lg font-bold" fontName="Large" fontSize="18px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-m font-normal" fontName="Medium" fontSize="16px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-m font-medium" fontName="Medium" fontSize="16px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-m font-bold" fontName="Medium" fontSize="16px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-sm font-normal" fontName="Small" fontSize="14px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-sm font-medium" fontName="Small" fontSize="14px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-sm font-bold" fontName="Small" fontSize="14px" fontWeight="Bold"/>
          <div className="separator" />

          <FontPreviewCell fontStyle="text-xs font-normal" fontName="XSmall" fontSize="12px" fontWeight="Regular"/>
          <FontPreviewCell fontStyle="text-xs font-medium" fontName="XSmall" fontSize="12px" fontWeight="Medium"/>
          <FontPreviewCell fontStyle="text-xs font-bold" fontName="XSmall" fontSize="12px" fontWeight="Bold"/>
        </div>
        )
    case 'item4':
      return (
        <div className="visualsContent">
          <h3 className="sectionTitle">Elevation</h3>
          <div className="elevationTable">
            <div className="elevationPreviewCell elevation-4">
              <div className="styleTitle">Elevation 4</div>
              <div className="styleSubtitle">elevation4</div>
            </div>
            <div className="elevationPreviewCell elevation-8">
              <div className="styleTitle">Elevation 8</div>
              <div className="styleSubtitle">elevation8</div>
            </div>
            <div className="elevationPreviewCell elevation-16">
              <div className="styleTitle">Elevation 16</div>
              <div className="styleSubtitle">elevation16</div>
            </div>
            <div className="elevationPreviewCell elevation-32">
              <div className="styleTitle">Elevation 32</div>
              <div className="styleSubtitle">elevation32</div>
            </div>
          </div>

          <div className="elevationTable">
            <div className="elevationPreviewCellText">
              <div className="styleTitle elevation-text">Text Shadow</div>
              <div className="styleSubtitle">textShadow</div>
            </div>
            <div className="elevationPreviewCellIcon elevation-icon">
              <div className="styleTitle">Icon Shadow</div>
              <div className="styleSubtitle">iconShadow</div>
            </div>
          </div>

          <h3 className="sectionTitle">Blur</h3>
          <div className="blurTable">
            <div className="blurPreviewCell blur-material">
              <div className="styleTitle">Blur Material</div>
              <div className="styleSubtitle">Blur background</div>
            </div>
          </div>

          <h3 className="sectionTitle">Corners</h3>
          <div className="cornersTable">
            <div className="cornerPreviewCell corner-2">
              <div className="styleTitle">2px</div>
            </div>
            <div className="cornerPreviewCell corner-4">
              <div className="styleTitle">4px</div>
            </div>
            <div className="cornerPreviewCell corner-8">
              <div className="styleTitle">8px</div>
            </div>
            <div className="cornerPreviewCell corner-16">
              <div className="styleTitle">16px</div>
            </div>
            <div className="cornerPreviewCell corner-24">
              <div className="styleTitle">24px</div>
            </div>
          </div>

          <h3 className="sectionTitle">Gradient Overlays</h3>
          <div className="overlaysTable">
            <div className="overlayPreviewCell gradient-overlay-8">
              <div className="styleTitle">Overlay 08</div>
            </div>
            <div className="overlayPreviewCell gradient-overlay-16">
              <div className="styleTitle">Overlay 16</div>
            </div>
            <div className="overlayPreviewCell gradient-overlay-24">
              <div className="styleTitle">Overlay 24</div>
            </div>
            <div className="overlayPreviewCell gradient-overlay-32">
              <div className="styleTitle">Overlay 32</div>
            </div>
            <div className="overlayPreviewCell gradient-overlay-40">
              <div className="styleTitle">Overlay 40</div>
            </div>
          </div>
        </div>
        )
    default:
      return (
        <div>
          You shouldn't be seeing this error.
        </div>
      )
  }
}

// Markup
const VisualsPage = () => {
  return (
    <main className="lighthouseView visualsView">
      <title>Visuals</title>

      <SidebarNavigation />

      <VisualsTabbedView />
    </main>
  )
}

export default VisualsPage
